module.exports = __webpack_public_path__ + "static/Grafik_family_mobile@2x.2deacfd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHeader/Hero/Grafik_family_mobile@2x.png
// module id = 427
// module chunks = 35783957827783